import React from 'react';
import autoBind from 'react-autobind';
import { getRoutes, getNameByUrl, getCurrentRoute } from '@common/router/router';
import { withRouter } from 'react-router';
import queryString from 'query-string';
import urlUtils from '@common/helpers/url.utils';
import alertasUtils from '@common/helpers/alertas.utils';

class RouterManager extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  redirect({ name, url, parameters, newTab }) {
    const routes = getRoutes();
    let urlRedirect = url;

    if (name) {
      const targetRoute = routes.find((x) => x.name == name);
      if (!targetRoute) {
        console.error(`A rota de nome "${name}" não está registrada!`);
        return;
      }
      urlRedirect = urlUtils.setUrlParameters(targetRoute.path, parameters, true);
    }

    if (parameters && parameters.forceRedirect) {
      this.forceRedirect(urlRedirect);
    } else {
      this.formControl(urlRedirect, newTab);
    }
  }

  async formControl(urlRedirect, newTab) {
    if (window._formControl && window.prefix && window.formUpdated && !window.isView && !window.isRedirectSaga) {
      let result = await _alert.confirm(
        'Deseja realmente sair? Note que qualquer mudança não salva será perdida.',
        'Cancelar'
      );
      if (result) {
        this.historyPush(urlRedirect);
      }
    } else {
      this.historyPush(urlRedirect, newTab);
    }
  }

  async forceRedirect(urlRedirect) {
    const urlForceRedirect = queryString.exclude(urlRedirect, ['forceRedirect']);
    this.historyPush(urlForceRedirect);
  }

  historyPush(urlRedirect, newTab) {
    window._formControl = undefined;
    window.formUpdated = undefined;
    window.onbeforeunload = undefined;
    window.onpopstate = undefined;
    window.isRedirectSaga = false;

    if (newTab) window.open(`${window.location.pathname}#${urlRedirect}`, '_blank');
    else this.props.history.push(urlRedirect);
  }

  get params() {
    return Object.assign(queryString.parse(this.props.location.search), this.props.match.params);
  }

  getCurrentRouteUrl() {
    const currentRoute = getCurrentRoute();

    if (window.location.hash.endsWith('tributario/') || window.location.hash.endsWith('#/')) return '/';
    else return currentRoute?.path;
  }

  componentDidMount() {
    alertasUtils.checkAlertas(true);
  }

  componentWillUnmount() {
    alertasUtils.checkAlertas(false);
  }

  render() {
    return this.props.children({
      redirect: this.redirect.bind(this),
      params: this.params,
      currentUrl: this.props.location.pathname,
      path: this.props.match.path,
      name: getNameByUrl(this.props.match.path),
    });
  }
}

export default withRouter(RouterManager);
